import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f7c85244"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pop" }
const _hoisted_2 = { class: "top" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon icon-back" }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon" }, null, -1))
const _hoisted_5 = { class: "search-wrap" }
const _hoisted_6 = { class: "content" }
const _hoisted_7 = { class: "group-item" }
const _hoisted_8 = { class: "group-item-text" }
const _hoisted_9 = { class: "main bold" }
const _hoisted_10 = { class: "sub" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = {
  key: 0,
  class: "icon icon-check"
}
const _hoisted_13 = { class: "circle-icon" }
const _hoisted_14 = ["src"]
const _hoisted_15 = { class: "group-item" }
const _hoisted_16 = { class: "group-item-text" }
const _hoisted_17 = { class: "main bold" }
const _hoisted_18 = { class: "sub" }
const _hoisted_19 = ["onClick"]
const _hoisted_20 = {
  key: 0,
  class: "icon icon-check"
}
const _hoisted_21 = { class: "circle-icon" }
const _hoisted_22 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_search = _resolveComponent("app-search")!
  const _component_bottom_pop_up_item = _resolveComponent("bottom-pop-up-item")!
  const _component_bottom_pop_up_item_wrapper = _resolveComponent("bottom-pop-up-item-wrapper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("a", {
        href: "javascript:void(0);",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('back'))),
        class: "back-link"
      }, [
        _hoisted_3,
        _createTextVNode(" " + _toDisplayString(_ctx.$localize('share.by.network.popup.view.all.backtext')), 1)
      ]),
      _createElementVNode("a", {
        href: "javascript:void(0);",
        onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.$emit('done')), ["prevent"])),
        class: "back-link"
      }, [
        _hoisted_4,
        _createTextVNode(" " + _toDisplayString(_ctx.$localize('share.by.network.popup.view.all.done.button')), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_app_search, {
        modelValue: _ctx.search,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.search) = $event)),
        onClear: _cache[3] || (_cache[3] = ($event: any) => (_ctx.search = ''))
      }, null, 8, ["modelValue"])
    ]),
    _createElementVNode("div", _hoisted_6, [
      (_ctx.type === _ctx.SHARE_ACCESS.GROUP && _ctx.filterGroups.length)
        ? (_openBlock(), _createBlock(_component_bottom_pop_up_item_wrapper, {
            key: 0,
            title: _ctx.$localize('share.by.network.popup.view.all.groups.title'),
            hideViewAll: ""
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filterGroups, (group) => {
                return (_openBlock(), _createBlock(_component_bottom_pop_up_item, {
                  class: "group-item",
                  key: group.id
                }, {
                  icon: _withCtx(() => [
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("img", {
                        src: _ctx.resolveGroupPhotoUrl(group),
                        alt: "group photo"
                      }, null, 8, _hoisted_14)
                    ])
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("p", _hoisted_9, _toDisplayString(group.name), 1),
                        _createElementVNode("p", _hoisted_10, _toDisplayString(group.groupInfo), 1)
                      ]),
                      _createElementVNode("div", {
                        class: "group-item-checkbox",
                        onClick: ($event: any) => (_ctx.onSelectGroup(group))
                      }, [
                        (group.selected)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_12))
                          : _createCommentVNode("", true)
                      ], 8, _hoisted_11)
                    ])
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }, 8, ["title"]))
        : _createCommentVNode("", true),
      (_ctx.type === _ctx.SHARE_ACCESS.SPECIFIC_PEOPLE && _ctx.filterContacts.length)
        ? (_openBlock(), _createBlock(_component_bottom_pop_up_item_wrapper, {
            key: 1,
            title: _ctx.$localize('share.by.network.popup.view.all.specific.title'),
            hideViewAll: ""
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filterContacts, (my) => {
                return (_openBlock(), _createBlock(_component_bottom_pop_up_item, {
                  class: "group-item",
                  key: my.user.accountId
                }, {
                  icon: _withCtx(() => [
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("img", {
                        src: _ctx.resolveContactPhotoUrl(my),
                        alt: "contact photo"
                      }, null, 8, _hoisted_22)
                    ])
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("p", _hoisted_17, _toDisplayString(_ctx.resolveFullName(my)), 1),
                        _createElementVNode("p", _hoisted_18, _toDisplayString(my.user.speciality), 1)
                      ]),
                      _createElementVNode("div", {
                        class: "group-item-checkbox",
                        onClick: ($event: any) => (_ctx.onSelectContact(my))
                      }, [
                        (my.selected)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_20))
                          : _createCommentVNode("", true)
                      ], 8, _hoisted_19)
                    ])
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }, 8, ["title"]))
        : _createCommentVNode("", true)
    ])
  ]))
}